import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const CardInfoStyle = styled.div`
  background: ${theme.greys.grey010};
  border-radius: 6px;
  padding: 16px 12px;

  .card-info-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    &__actions {
      display: flex;
      &__item {
        padding: 4px;
        margin-left: 8px;
        cursor: pointer;
        width: 24px;
        height: 24px;
        img {
          width: 16px;
        }
      }
    }
  }
  .card-info-data {
    li {
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0px;
      }
    }

    .card-info-data__attribute:not(:last-of-type) {
      margin-bottom: 12px;
    }

    .card-info-data__title {
      margin-bottom: 8px;
      color: ${theme.type.secondary};
    }
    .card-info-data__item {
      color: ${theme.type.secondary};
    }

    .card-info-data__hidden {
      display: flex;
      justify-content: space-between;

      &-item {
        cursor: pointer;
      }
    }

    &__separator {
      width: 100%;
      margin: 16px 0;
      padding: 0 12px;
      border-bottom: 1px solid ${theme.type.disabled};
    }
  }

  .MuiButtonBase-root {
    min-width: 0;
    width: 36px;
    height: 36px;
  }
`;
